export type PolygonPointArray = string[] | number[][];

export type ColoredPolygon = { points: PolygonPointArray; color: string };

export type PolygonEntry = PolygonPointArray | ColoredPolygon;

export interface AiDetectionResult {
  class: string;
  Condition?: string;
  Severity?: string;
  showForGender?: string;
  scalp_masks?: string;
  BoundingBoxes?: string[];
  PolygonPointsSequences?: PolygonEntry[];
  ellipse_points?: { left?: string[]; right?: string[] };
  hairline_points?: string[];
  ProblemName?: string;
  severity?: string;
}

export type SyntheticPolygonResult = Partial<Omit<AiDetectionResult, 'PolygonPointsSequences'>> & {
  PolygonPointsSequences: PolygonEntry[];
};

export type DisplayDetectionResult = AiDetectionResult | SyntheticPolygonResult;

export type ScalpViewMode = 'outline' | 'filled';

export const TEAL_DETECTION_COLOR = '#4EAE9C';

// Normalized (Title-case) scalp severity values returned by the AI detection.
export const ScalpSeverity = {
  Normal: 'Normal',
  Mild: 'Mild',
  Moderate: 'Moderate',
  Severe: 'Severe',
  Unknown: 'Unknown',
} as const;

// Single discriminated state for the scalp card on the HAIR_TOP view. Replaces the
// previous combination of hasScalpDetections() + showNoScalpDetectionCard booleans.
//   Detected    – an abnormal scalp-segment with drawable masks (overlay + warning copy)
//   Normal      – a Normal-severity scalp-segment (positive copy, no overlay), any Condition
//   NoDetection – experiment says show the "No visible scalp area" card
//   None        – not HAIR_TOP, or nothing to show
export enum ScalpCardState {
  Detected = 'DETECTED',
  Normal = 'NORMAL',
  NoDetection = 'NO_DETECTION',
  None = 'NONE',
}
